export default __webpack_public_path__ + "static/media/times-new-roman.f85717da.ttf";